import React from 'react';

import './_season-record.scss';

const SeasonRecord = (props) =>
  (<div className="col-lg-6 records">
    <div className="row mx-lg-2 mb-5 mb-lg-2 clippedbox--color-dark-small text-center">
      <h2 className="heading--gray my-4 col-12">{props.title}</h2>
      <div className="col-6 px-0 mb-1">
        <p className="heading--gray">Team</p>
      </div>
      <div className="col-3 px-0">
        <p className="heading--gray">Year</p>
      </div>
      <div className="col-3 px-0">
        <p className="heading--gray">{props.label}</p>
      </div>
        {props.data.map((item, i) =>(
          <React.Fragment key={i}>
            <div className="col-12 alt">
              <div className="row flex-center">
            <div className="col-6 flex-center pr-0">
              <p  className="rank-number">{i + 1}</p>
                  <img alt="team-logo" src={item.image} className="image" onError={function (ev) { 
                    ev.target.src = "https://fantasy-franchise.com/img/DEF.png";
                    }} />
              <p className="name">{item.name}</p>
            </div>
            <div className="col-3 px-0 text-center">
              <p>{item.year}</p>
            </div>
            <div className= "col-3 px-0 text-center">
            {props.label === "Wins" && <p>{item.wins}</p>}
            {props.label === "Loses" && <p>{item.loses}</p>}
            {props.label === "Percentage" && <p>{item.pct}</p>}
            {props.title === "Most Points" && <p>{item.scoreFor}</p>}
            {props.title === "Less Points" && <p>{item.scoreFor}</p>}
            {props.title === "Most Points Agaisnt" && <p>{item.scoreAgaisnt}</p>}
            {props.title === "Less Points Agaisnt" && <p>{item.scoreAgaisnt}</p>}
            {props.title === "Most Points Avg/Game" && <p>{item.avgPoints}</p>}
            {props.title === "Less Points Avg/Game" && <p>{item.avgPoints}</p>}
            {props.label === "Times" && <p>{item.scoreTimes}</p>}



          
            </div>
              </div>
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>);

export default SeasonRecord;
